import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { ensureSession } from '../lib/session';

export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context, location }) => {
    const state = await ensureSession(context.queryClient);
    if (state.status !== 'authenticated') {
      throw redirect({
        to: '/signin',
        search: { from: location.pathname },
      });
    }
  },
  component: AuthedLayout,
});

function AuthedLayout() {
  return <Outlet />;
}
